import { useQuery } from 'react-query';
import { queryConsultations } from './useConsultations.query';
import { PageQueryParams } from '../../../types/api/api.types';
import { UseConsultationsResponse } from './useConsultations.types';

export const ALL_CONSULTATIONS_QUERY_KEY = 'ALL_CONSULTATIONS';

export const useConsultations = (params: PageQueryParams) => {
  return useQuery<UseConsultationsResponse, Error>(
    ALL_CONSULTATIONS_QUERY_KEY,
    () => queryConsultations(params),
    {
      retry: false,
    }
  );
};
